import React, { useState } from "react";
import { useHistory } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';

const StatusCard = ({ iconName, name, number, statusCardStyle, statusCardClassNames = [], iconClassNames = [], statusCardTextClassNames = [], pathName = null, isLoading = false }) => {
    const [redirect, setRedirect] = useState(null);

    const history = useHistory();

    const handleRedirect = () => {
        if (!pathName) return;
        setRedirect(pathName);
    };

    if (redirect) return history.push(redirect);

    return (
        <div className={`status-card ` + [...statusCardClassNames]} style={statusCardStyle} onClick={handleRedirect}>

            <div className="icon">
                <div className="top-left">
                    <i className={`${iconName} ` + [...iconClassNames]}></i>
                </div>

                <div className="top-right">
                    <i className={`fas fa-info-circle ` + [...iconClassNames]}></i>
                </div>
            </div>

            <div className="cardContent mt-6">
                <div className={`cardName mb-0 ` + [...statusCardTextClassNames]}>{name}</div>
                <div className="cardStatus">{isLoading ? 'En cours' : 'Chargement...'}</div>
                <div className={`cardNumber ` + [...statusCardTextClassNames]}>
                    {isLoading ? number : <ProgressSpinner style={{ width: '50px', height: '50px' }} />}
                </div>
            </div>

        </div >
    );
};

export default StatusCard;